import { opacity } from '../../../utils';
import { colorsDark } from '../../../themes';

export const tableDarkTheme = {
  header: {
    background: opacity(colorsDark.gray[500], 10),
    border_color: colorsDark.gray[400],
    cellHighlight: opacity(colorsDark.blue[100], 40),
  },
  body: {
    background: 'transparent',
    border_color: colorsDark.gray[400],
    row: {
      hover_background: opacity(colorsDark.gray[100], 50),
      datatable_hover_background: colorsDark.royalBlue[100],
      focusedRow: {
        border: `1px solid ${colorsDark.gray[900]}`,
        shadow: `0 0 13px 1px ${opacity(colorsDark.blue[200], 40)}`,
      },
      selected: {
        background: colorsDark.blue[100],
        hover: {
          background: colorsDark.blue[100],
        },
      },
    },
    cellHighlight: colorsDark.blue[100],
  },
};
